module.exports = __webpack_public_path__ + "static/media/scss.c5f5c519.png";